"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_rdf_metadata_extract_1 = require("@comunica/bus-rdf-metadata-extract");
/**
 * An RDF Metadata Extract Actor that extracts total items counts from a metadata stream based on the given predicates.
 */


var ActorRdfMetadataExtractHydraCount =
/*#__PURE__*/
function (_bus_rdf_metadata_ext) {
  _inherits(ActorRdfMetadataExtractHydraCount, _bus_rdf_metadata_ext);

  function ActorRdfMetadataExtractHydraCount(args) {
    _classCallCheck(this, ActorRdfMetadataExtractHydraCount);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorRdfMetadataExtractHydraCount).call(this, args));
  }

  _createClass(ActorRdfMetadataExtractHydraCount, [{
    key: "test",
    value: function () {
      var _test = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", true);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function test(_x) {
        return _test.apply(this, arguments);
      }

      return test;
    }()
  }, {
    key: "run",
    value: function run(action) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        // Forward errors
        action.metadata.on('error', reject); // Immediately resolve when a value has been found.

        action.metadata.on('data', function (quad) {
          if (_this.predicates.indexOf(quad.predicate.value) >= 0) {
            resolve({
              metadata: {
                totalItems: parseInt(quad.object.value, 10)
              }
            });
          }
        }); // If no value has been found, assume infinity.

        action.metadata.on('end', function () {
          resolve({
            metadata: {
              totalItems: Infinity
            }
          });
        });
      });
    }
  }]);

  return ActorRdfMetadataExtractHydraCount;
}(bus_rdf_metadata_extract_1.ActorRdfMetadataExtract);

exports.ActorRdfMetadataExtractHydraCount = ActorRdfMetadataExtractHydraCount;